import { Component, Inject, Input } from '@angular/core';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';

@Component({
  selector: 'ui-fh-svg-images',
  templateUrl: './fh-svg-images.component.html',
  styleUrl: './fh-svg-images.component.scss'
})
export class FhSvgImagesComponent {
  appConfig: EnvironmentModel = new EnvironmentModel();
  @Input() name: string = '';
  @Input() color: string = '';
  @Input() secondaryColor?: string = '';

  constructor(@Inject(APP_CONFIG) protected appConfigTemp: EnvironmentModel) {
    this.appConfig = appConfigTemp;
    this.color = this.appConfig.colorPrimary;
    this.secondaryColor = this.appConfig.colorPrimaryTint;
  }
}
